<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9" md="6">
          <v-sheet class="neu-glow with-radius fill-height pa-3" height="100%">
            <v-img
              src="/static/ob-animated/admin-animate.svg"
              lazy-src="/static/ob-animated/admin-animate.svg"
              height="400"
              contain
            >
            </v-img>
            <v-layout row wrap justify-center>
              <div 
                align-center
                class="md-grow-0"
                >
                  <v-img
                  src="/static/logos/company_logo.svg"
                  lazy-src="/static/logos/company_logo.svg"
                  width="320"
                  ></v-img>
              </div>
            </v-layout>
            <v-row justify="end" class="fill-height">
              <v-col class="text-center px-10" cols="12">
                <div class="text-body-1 my-7">
                  <h1>Boss' Settings Page</h1>
                </div>
                <v-btn class="mb-3" color="secondary" to="/"
                  >Back To Home</v-btn
                >
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      page: "BossSettings",
      ob_dialog:false,
      ob_s1:'H',
    };
  },
  created(){
    this.loadData();
  },
  computed:{
    ...mapGetters("scheme", ["dark", "semidark", "header", "footer", "rtl"]),
  },
  methods:
  {
    async loadData(){
      this.$vuetify.theme.dark = 1;
      let jwt=sessionStorage.getItem('jwt');
      console.log('start');
      try{
          const res = await this.$http.post('/settings/settings_get.php', {"jwt":jwt});
          if (res.data.errorid=='0')
          { 
            this.$store.dispatch("setUser", res.data.user); 
            this.$store.dispatch("setLocale", res.data.user.locale);
            this.$store.dispatch("setCurrency", res.data.user.currency);
          }
          else
          {
            this.loader=false;
            this.$router.push('/auth/login').catch(() => {});
            //this.$router.go();
          }      
      } catch(e)
      {
        //this.$router.go();
      }
      this.loader=false;
    },
  }
};
</script>